import React from 'react';
import arrowImg from '../../../_assets/sass/pages/chatbot/arrow.svg';

const BlueChat = (props) => {
    let { msg  } = props;
    const blueData = Array.isArray(msg) ? msg[0] : msg;
   const handleClick = () => {
        window.open(blueData.buttonDeepLink,'_blank');
    };
    if (!blueData || blueData.parentId !== 4 )
    {
      return null;
    }


    return (<>
        <div className="loyalty-card">
      <div className="cardheader">
         {blueData.icon  && (
        <div className="crown-icon-container">
          <span role="img" aria-label="crown" className="crown-icon"><img src={blueData.icon} /></span>
        </div>
         )}
        {blueData.buttonText  && blueData.buttonDeepLink && (
          <div className="tier-badge" onClick={handleClick}>
            <span className="tier-text">{blueData.buttonText}</span>
          </div>
        )}
      </div>

      <div className="card-body">
        <h2 className="program-title">{blueData.title}</h2>
        <p className="points">{blueData.pointsText}</p>
      </div>

      <div className="card-footer">
        <p className="progress-text">
        {blueData.description.split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
        </p>

        <div className="progress-bar-container">
          <div className="progress-bar" style={{ width: `${blueData.percent}` }}></div>
          <div className="progress-marker" style={{ left: `${blueData.percent}` }}>
            {/* <span className="marker-arrow"><img src={msg.icon} /></span> */}
           <span className="marker-arrow"><img src={arrowImg} /></span> 
          </div>
        </div>
      </div>
    </div>
        </>
    );
};

export default BlueChat;